import { CircleCheck, CircleX } from 'lucide-react'

type Props = {
  children?: React.ReactNode
  variant: 'success' | 'error'
}

export const ToasterContent = ({ variant, children }: Props) => {
  if (variant === 'success') {
    return (
      <div className="flex items-center gap-1">
        <CircleCheck className="size-4 min-w-4 min-h-4 fill-emerald-600 stroke-background" />
        {children}
      </div>
    )
  }
  if (variant === 'error') {
    return (
      <div className="flex items-center gap-1">
        <CircleX className="size-4 min-w-4 min-h-4 fill-destructive stroke-background" />
        {children}
      </div>
    )
  }
}
